// extracted by mini-css-extract-plugin
export default {"ConsolidationText":"ConsolidationText-styles__ConsolidationText__Lj7Br","ConsolidationText__introCopy":"ConsolidationText-styles__ConsolidationText__introCopy__naUMm"};